import React, { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { PrimaryButton } from '@/styles/blocks';
import ExportSplitButton from '@/components/Accounting/ExportSplitButton';
import { FILTERS } from './constants';
import { UserContext } from '@/components/App';
import { GetApp as DownloadIcon } from '@material-ui/icons';

function Footer({ state, loading, callbacks }) {
    const { user } = useContext(UserContext);
    const isAdmin = user?.roles?.['ONWARD_ADMIN'] || user?.roles?.['ADMIN'];
    // With one option the button keeps its original "Export" label.
    const exportOptions = state.exportOptions?.length > 1 ? state.exportOptions : ['Export'];

    // Dispatch on the label rather than the index: index 1 is Electrolux CSV or MasterBrand CSV
    // depending on which flag the selection carries.
    const handleExport = (index) => {
        switch (exportOptions[index]) {
            case 'Electrolux CSV':
                return callbacks.exportElectroluxCsv();
            case 'Electrolux TXT':
                return callbacks.exportElectroluxTxt();
            case 'MasterBrand CSV':
                return callbacks.exportMasterbrandCsv();
            case 'Peloton CSV':
                return callbacks.exportPelotonCsv();
            default:
                return callbacks.exportCsv();
        }
    };

    return (
        <>
            <Grid
                container
                css={css`
                    padding: 1rem;
                    background-color: white;
                    justify-content: center;
                    align-items: center;
                `}
            >
                <Grid
                    item
                    css={css`
                        margin-right: 16px;
                    `}
                >
                    <PrimaryButton
                        css={css`
                            & > div:first-of-type {
                                display: flex !important;
                                flex-direction: row !important;
                                align-items: center !important;
                                justify-content: center !important;
                                gap: 6px !important;
                            }
                        `}
                        onClick={callbacks.downloadAllPODs}
                        loading={loading.downloadingPODs}
                        disabled={state.selected.length === 0 || loading.downloadingPODs}
                    >
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                            PODs
                            <DownloadIcon style={{ fontSize: '18px', width: '18px', height: '18px' }} />
                        </span>
                    </PrimaryButton>
                </Grid>
                <Grid
                    item
                    css={css`
                        margin-right: 16px;
                    `}
                >
                    <ExportSplitButton
                        options={exportOptions}
                        selectedIndex={state.selectedExportIndex || 0}
                        onSelect={callbacks.setSelectedExportIndex}
                        onExport={handleExport}
                        disabled={state.selected.length === 0}
                        loading={loading.exportCsv}
                    />
                </Grid>
                {isAdmin && state.filter.status === FILTERS.DRAFT ? (
                    <Grid item>
                        <PrimaryButton
                            loading={loading.update}
                            onClick={callbacks.setSubmitted}
                            disabled={state.selected.length === 0}
                        >
                            Submit
                        </PrimaryButton>
                    </Grid>
                ) : null}
                {state.filter.status === FILTERS.NOT_PAID ? (
                    <Grid item>
                        <PrimaryButton
                            loading={loading.update}
                            onClick={callbacks.setApproved}
                            disabled={state.selected.length === 0}
                        >
                            Approve
                        </PrimaryButton>
                    </Grid>
                ) : null}
                {state.filter.status === FILTERS.APPROVED ? (
                    <Grid item>
                        <PrimaryButton
                            loading={loading.update}
                            onClick={callbacks.setPaid}
                            disabled={state.selected.length === 0}
                        >
                            Mark as Paid
                        </PrimaryButton>
                    </Grid>
                ) : null}
            </Grid>
        </>
    );
}

export default Footer;
